export class Category {
  id: number;
  name: string = '';
  slug: string;
  description: string;
  link: string;
}
